<template>
  <v-flex xs12 sm10 md6 class="entry__container">
    <div class="app-logo text-xs-center pb-5">
      XProperty
    </div>
    <v-card elevation="2" class="pa-4">
      <v-card-title primary-title class="py-3">
        <h1>Login</h1>
        <p>version {{version}}</p>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <span data-icon="&#x25a8;" />
          <v-text-field
            v-model="username"
            label="Username/Email"
            :rules="textRules"
            required
          />
          <v-text-field
            v-model="password"
            label="Password"
            required
            :type="'password'"
            :rules="textRules"
            @keyup.enter="logInClicked"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="py-3">
        <v-btn flat router to="/forgetPassword">Forget Password</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" @click="logInClicked"
          >Log In</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import {version} from '../../package'
import { mapActions } from 'vuex'
import alertHelper from '@/helpers/alert'

export default {
  data() {
    return {
      counter: 0,
      username: '',
      password: '',
      valid: true,
      textRules: [(v) => !!v || 'This field is required'],
    }
  },
  computed: {
    version() { return version }
  },
  methods: {
    ...mapActions({
      logIn: 'User/loggingIn',
    }),
    logInClicked() {
      if (this.$refs.form.validate()) {
        this.logIn({
          username: this.username,
          password: this.password,
        })
      } else {
        alertHelper.error('Please enter the required details')
      }
    },
  },
}
</script>
